import { map, Observable } from 'rxjs';
import { SessionService } from 'src/app/utils';
import { v4 } from 'uuid';
import { ChromeBoxMessagesService } from '../services/chrome-box-messages.service';

export const generateDeviceUUID = (
    chromeBoxMessagesService: ChromeBoxMessagesService,
    sessionService: SessionService,
): Observable<string> => {
    return chromeBoxMessagesService.getDeviceUUID()
        .pipe(
            map(uuid => {
                if (uuid) {
                    return uuid;
                }
                const params = new Proxy(new URLSearchParams(window.location.search), {
                    get: (searchParams, prop: string) => searchParams.get(prop),
                });

                const token = v4();
                return sessionService.getCodeFromLocal(params['serial'] || token);
            })
        );
}